import gql from 'graphql-tag';

export default gql`
  fragment mailAddressFragment on MailAddress {
    name
    mail
  }
`;
